export const fieldsInfo: any = {

  dateFields: [
    'expiration_date',
    'effective_date',
    'file_date_modified',
  ],

  selectFields: [
    'background',
    'orientation_view',
    'country',
    'language',
    'color_mode',
    'resolution',
    'uom',
    'file_type',
    'third_party_asset',
    'hemisphere',
    'duration_uom',
  ],

  textFields: [
    'description',
    'additional_info',
  ],

  readonlyFields: [
  ],

  quarteredSizeFields: [
    'width',
    'height',
    'uom'
  ],

  fullSizeFields: [
    'filename',
    'uri',
    'description',
    'additional_info'
  ],

};
